import {useStore} from 'effector-react';
import {useEffect} from 'react';
import {Link} from 'react-router-dom';
import {Image} from '../../../components/Image';
import $appStore from '../../../store/app/store';
import {getUrl} from '../../../utils/utils';
import './FreskaFylla.scss';
interface IFreskaFylla {
  title: string;
  subtitle: string;
  url: any;
  image: string;
}

export const FreskaFylla = (props: IFreskaFylla) => {
  const {title, subtitle, image, url} = props;
  const appStore = useStore($appStore);

  useEffect(() => {
    url && getUrl(appStore.language, url[0].__typename, url[0].flatData.friendlyUrl);
  }, [url]);

  return (
    <div className="categoriesFreskaFylla">
      <div className="categoriesFreskaFylla-inner">
        <Link
          to={getUrl(appStore.language, url[0].__typename, url[0].flatData.friendlyUrl)}
          className="categoriesFreskaFylla-inner-image"
        >
          <Image imageUrl={image} imageClass={''} imageAlt={title} config={'width=1000'} />
        </Link>
        <Link
          to={getUrl(appStore.language, url[0].__typename, url[0].flatData.friendlyUrl)}
          className="categoriesFreskaFylla-inner-texts"
        >
          <div className="categoriesFreskaFylla-inner-texts-title">{title}</div>
          <div className="categoriesFreskaFylla-inner-texts-subtitle">{subtitle}</div>
          <div className="categoriesFreskaFylla-inner-texts-arrow">
            <Image imageUrl="arrow.svg" imageAlt={title} config={'cache=2630000&width=30'} />
          </div>
        </Link>
      </div>
    </div>
  );
};
